import React, { type JSX } from "react";
import Euro from "@mui/icons-material/Euro";

import { LocalizedNumberField, type LocalizedNumberFieldProps } from "./LocalizedNumberField";

export type EuroFieldProps = Omit<
	LocalizedNumberFieldProps,
	"icon" | "iconBackgroundColor" | "decimalScale" | "fixedDecimalScale" | "roundingMode"
>;

/**
 * Specialized number field for Euro currency values.
 * - Shows Euro icon
 * - Fixed 2 decimal places
 * - Commercial rounding (halfUp)
 * - Localized thousand and decimal separators
 */
export function EuroField(props: EuroFieldProps): JSX.Element {
	return (
		<LocalizedNumberField
			{...props}
			icon={<Euro />}
			iconBackgroundColor="#1a455c"
			decimalScale={2}
			fixedDecimalScale={true}
			roundingMode="halfUp"
		/>
	);
}
